export default __webpack_public_path__ + "static/media/pluggedError.ffe2935f.svg";